import React, { useState } from 'react';
import './index.scss';
import { CLIENT_DOMAINS, CLIENTS, isLogoInBanner } from '../../utils/basic';

const Banner = ({ pathPrefix = '' }: { pathPrefix?: string }) => {
  const [show, setShow] = useState(true);

  const getDomainName = () => {
    const client = pathPrefix.toLowerCase();
    const isValidClient = CLIENTS.includes(client);
    if (!isValidClient) return 'lashbrookdesigns';
    return CLIENT_DOMAINS[client] || client;
  };

  // Ben Bridge layout: the wordmark is pinned to the left inside the promo bar
  // and the message stays centred on the bar independently of it, mirroring how
  // .close-icon is pinned right. The default branch below instead lays the bar
  // out with justify-between plus a spacer, which centres the message relative
  // to the logo rather than to the bar, and adds a second below-bar logo for
  // phones. Hidden under sm: at 640px and down the centred message already runs
  // most of the bar's width, so the wordmark would sit underneath it.
  if (isLogoInBanner(pathPrefix)) {
    return (
      <>
        {show && (
          <div className="tw-h-10 tw-px-6 tw-bg-brand-color tw-flex-grow-0 tw-shrink-0 tw-flex tw-justify-center tw-items-center tw-text-tertiary-color tw-text-sm tw-relative secondary-font-family">
            <a href={`https://www.${getDomainName()}.com/`} className="tw-hidden sm:tw-block banner-logo-link">
              <img className="brand-logo-secondary banner-logo" alt="logo" />
            </a>
            <p>FREE at-home sizing kit with every order!</p>
            <i
              className="fa-sharp fa fa-xmark tw-text-base tw-cursor-pointer close-icon"
              onClick={() => setShow(false)}
            ></i>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      {show && (
        <>
          <div className="tw-h-10 tw-px-6 tw-bg-brand-color tw-flex-grow-0 tw-shrink-0 tw-flex tw-justify-center sm:tw-justify-between tw-items-center tw-text-tertiary-color tw-text-sm tw-relative secondary-font-family">
            <a href={`https://www.${getDomainName()}.com/`} className="tw-hidden sm:tw-inline-block">
              <img className="brand-logo" alt="logo" />
            </a>
            <p>FREE at-home sizing kit with every order!</p>
            <p />
            <i
              className="fa-sharp fa fa-xmark tw-text-base tw-cursor-pointer close-icon"
              onClick={() => setShow(false)}
            ></i>
          </div>
          <a href={`https://www.${getDomainName()}.com/`} className="tw-inline-block sm:tw-hidden">
            <img className="brand-logo-secondary" alt="logo" />
          </a>
        </>
      )}
    </>
  );
};

export default Banner;
